import React from 'react'
import { connect } from 'react-redux'
import SizeActions from '../../Redux/SizeRedux'
import { currentBranch } from '../../Utils/PrivilegeUtils'

class UpdateSize extends React.Component {
  constructor (props) {
    super(props)
    this.branch = currentBranch()
    this.state = {
      form: {
        name: props.detail.name || '',
        category_id: props.detail.category_id
      },
      id_name: props.detail.category.name || ''
    }
  }

  _inputChange = (event, field) => {
    let value = event.target.value
    let form = { ...this.state.form }
    form[field] = value
    this.setState({ form })
  }

  _submit = (event) => {
    event.preventDefault()
    let form = { ...this.state.form }
    const data = {
      id: this.props.detail.id,
      form
    }
    this.props.updateSize(data)
    setTimeout(() => {
      this.props.closeModal()
    }, 250)
  }

  render () {
    return (
      <div className='section' style={{ width: '40vw' }}>
        <div className='title-block'>
          <h4 className='title mr-auto'>Update Subtype</h4>
        </div>
        <form onSubmit={(event) => this._submit(event)}>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>For Category</label>
            </div>
            <div className='col-9'>
              <input
                className='form-control'
                type='text'
                disabled
                value={this.state.id_name}
              />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Edit subtype</label>
            </div>
            <div className='col-9'>
              <input
                type='text'
                required
                placeholder='Insert subtype name'
                className='form-control'
                value={this.state.form.name}
                onChange={(event) => this._inputChange(event, 'name')}
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-12 text-right'>
              <button type='button' className='btn btn-secondary mr-2' onClick={() => this.props.closeModal()}>Cancel</button>
              <button type='submit' className='btn btn-primary'>Save</button>
            </div>
          </div>
        </form>
      </div>
    )
  }
}

const stateToProps = (state) => ({})

const dispatchToProps = (dispatch) => ({
  updateSize: (data) => dispatch(SizeActions.updateSizeRequest(data))
})

export default connect(stateToProps, dispatchToProps)(UpdateSize)



// WEBPACK FOOTER //
// ./src/Containers/Ecommerce/UpdateSize.js